module.exports = { src: __webpack_public_path__ + "media/tile-1-overlay.90781382.webp", width: 365, height: 400 };